// =============================================================================
// useUnloadWarning — the browser's own "leave site?" prompt, while a screen
// holds unsaved work.
//
// Tab close and hard reload are the one exit no in-app control can intercept,
// so this is the only guard that reaches them. The browser supplies the
// wording; we cannot phrase it, which is exactly why it is a backstop and not
// the guard: the in-app question (confirmLeavePage) is the one an operator
// actually reads.
//
// Extracted because the same six lines had been written out four times
// (ExporterConfig, ExporterShipmentDetail, ExporterInvoices, and then
// usePageDirtyGuard). Most pages should not reach for this directly —
// usePageDirtyGuard installs it, and gets the in-app half too.
// =============================================================================

import { useEffect } from 'react'

export function useUnloadWarning(active: boolean): void {
  useEffect(() => {
    if (!active) return
    const warn = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = '' }
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [active])
}
